import { get } from 'lodash/object';

import { setTimeout, $contentArea } from 'utils/wrappers';

export function flash(message, klass, options = {}) {
  const contentArea = $contentArea();
  let flashContainer = contentArea.find('.flash-container');

  if (!flashContainer.length) {
    contentArea.prepend("<div class='flash-container'></div>");
    flashContainer = contentArea.find('.flash-container');
  }

  const alertHtml = $(`${'' +
    '<div class="alert alert-dismissible '}${klass}">` +
    '<button type="button" class="close" data-dismiss="alert" aria-label="Close">\n' +
    '  <span aria-hidden="true">&times;</span>\n' +
    '</button>' +
    `<div class="text-center">${message}</div>` +
    '</div>');

  flashContainer.append(alertHtml);

  if (!options.noClose) {
    setTimeout(() => {
      alertHtml.fadeOut(400, () => {
        alertHtml.remove();
        if (!flashContainer.children().length) {
          flashContainer.remove();
        }
      });
    }, 8000);
  }
}

export function showError(message, options) {
  flash(message, 'alert-danger', options);
}

export function showErrorWithSupportLink(message, options) {
  showError(
    `${message} If the problem persists please contact us at ` +
    '<a href="mailto:support@easypost.com" target="_blank">support@easypost.com</a>.',
    options,
  );
}

export function showUnknownError() {
  showErrorWithSupportLink('An unknown error occurred while contacting the easypost service.');
}

export function showSuccess(message) {
  flash(message, 'alert-success');
}

export function isUnknownError(response) {
  return response.status === 0 || !response.responseJSON;
}

export const parseResponseError = response => (
  get(response, 'responseJSON.error.message') ||
  get(response, 'responseJSON.message') ||
  get(response, 'responseJSON.error.code') ||
  get(response, 'responseJSON.code')
);

export function _handleUnknownErrors(response, fn, val) {
  if (isUnknownError(response) || !val) {
    showUnknownError();
  }
  if (val) {
    fn(val);
  }
}

export function handleResponseError(response, fn) {
  const errMsg = parseResponseError(response);
  _handleUnknownErrors(response, fn, errMsg);
}

export function handleResponseErrors(response, fn) {
  const errors = get(response, 'responseJSON.error.errors');
  _handleUnknownErrors(response, fn, errors);
}

export function showResponseError(response) {
  handleResponseError(response, showError);
}

export function hideFlash() {
  $contentArea().find('.flash-container').html('');
}



// WEBPACK FOOTER //
// ./utils/messages.js